import Stack from "@mui/material/Stack/Stack";
import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import { Button, Fab, Input, TextField, Typography } from "@mui/material";
import QrCodeIcon from "@mui/icons-material/QrCode";
import { Container } from "@mui/system";
import DrawerAppBar from "../../../../../components/mobile/Navbar";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SeparationState, separationActions } from "../../store";
import { InventoryReservation } from "../../../../../../domain/models/inventory-reservation";
import { NormalizedCargoItem } from "../../../../../../domain/models/cargo-model";
import { SeparateReservation } from "../../../../../../domain/usecases/separate-reservation";
import { useDispatch } from "react-redux";

type Props = {
  separateReservation: SeparateReservation;
};

export const SeparationProductCollector: React.FC<Props> = ({
  separateReservation,
}) => {
  const [code, setCode] = useState<string>("");
  const [batch, setBatch] = useState<string>("");
  const [amount, setAmount] = useState<string>("");
  const [finish, setFinish] = useState<boolean>(false);

  const item = useSelector<SeparationState, NormalizedCargoItem | null>(
    (state) => state.currentItem!.item
  );

  const reservation = useSelector<SeparationState, InventoryReservation | null>(
    (state) => state.currentItem!.reservation
  );

  const navigate = useNavigate();

  const handleConfirm = async () => {
    if (!code) return alert("Insira o código do produto antes de continuar");
    if (item?.batch && !batch)
      return alert("Confirme o lote do produto antes de continuar");
    if (!amount)
      return alert("Confirme a quantidade do produto antes de continuar");
    if (code !== item?.eanCode) return alert("O código do produto está errado");
    if (
      batch.trim().toUpperCase().split(" ").join("") !==
      item?.batch?.trim().toUpperCase().split(" ").join("")
    )
      return alert("O lote do produto está errado");
    if (
      Number((parseFloat(amount) * (item.packageAmount || 1)).toFixed(2)) !==
      reservation?.amount
    ) {
      return alert("A quantidade do produto está errado");
    }

    const res = await separateReservation.separate(reservation!);

    if (!res) {
      alert("Falha ao realizar a separação. Reinicie o processo.");
      return navigate("/mobile/separation/items");
    }

    alert("Item separado com sucesso!");
    return navigate("/mobile/separation/items");
  };

  return (
    <>
      <DrawerAppBar
        title="Coletar dados do produto"
        onBack={() => {
          navigate("/mobile/separation/position-collector");
        }}
      />

      <Stack sx={{ m: "20px" }} spacing={4}>
        <Paper>
          <Stack spacing={4} sx={{ mx: "10px", my: "30px" }}>
            <Typography>{item?.productDescription}</Typography>
            <Stack direction="row">
              <TextField
                id="outlined-basic"
                label="Código do Produto"
                variant="outlined"
                sx={{
                  mx: "5px",
                }}
                value={code}
                onChange={(e) => {
                  setCode(e.target.value);
                }}
              />
              <Button
                variant="outlined"
                color="inherit"
                sx={{
                  mx: "5px",
                }}
              >
                <QrCodeIcon />
              </Button>
            </Stack>
            {!finish ? (
              <>
                {item?.batch && (
                  <Typography variant="h4">{`Lote: ${item?.batch}`}</Typography>
                )}
                <Typography variant="h4">{`Quantidade: ${(
                  reservation!.amount / (item!.packageAmount || 1)
                ).toFixed(2)}`}</Typography>
              </>
            ) : (
              <>
                <Typography variant="h6">{`Confirme o lote e a quantidade.`}</Typography>
                {item?.batch && (
                  <TextField
                    id="outlined-basic"
                    label="Lote"
                    variant="outlined"
                    sx={{
                      mx: "5px",
                    }}
                    value={batch}
                    onChange={(e) => {
                      setBatch(e.target.value);
                    }}
                  />
                )}
                <TextField
                  id="outlined-basic"
                  label="Quantidade"
                  variant="outlined"
                  sx={{
                    mx: "5px",
                  }}
                  value={amount}
                  onChange={(e) => {
                    setAmount(e.target.value);
                  }}
                />
              </>
            )}
          </Stack>
        </Paper>
        <Button
          variant="contained"
          color="secondary"
          sx={{ color: "white", height: "50px", fontWeight: "bold" }}
          onClick={() => {
            if (!finish) {
              setFinish(true);
            } else {
              handleConfirm();
            }
          }}
        >
          {finish ? "Finalizar" : "Continuar"}
        </Button>
      </Stack>
    </>
  );
};
